<template>
  <v-container fluid class="fill-height">
    <!-- TOP: Title -->
    <v-row justify="center">
      <v-col cols="12" align="center">
        <span class="text-h2 font-weight-bold grey--text text--darken-3">
          {{ $t("default") }}
        </span>
      </v-col>

      <v-col cols="8" class="py-8">
        <v-row align="start" justify="center">
          <v-col
            align="center"
            :cols="menu.col"
            v-for="(page, index) in filteredPages"
            :key="index"
            class="mb-2"
          >
            <v-card
              @click="goto(page)"
              class="menuItem d-flex flex-column align-center justify-center"
              :width="menu.width"
              :height="menu.height"
              elevation="8"
              :ripple="false"
            >
              <v-img
                :src="page.displayIcon.url"
                :width="menu.imageWidth"
                contain
              />
              <v-card-text class="text-h5 primary--text font-weight-bold">
                {{ page.pageName }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-auto pb-4">
      <v-col cols="12">
        <v-divider class="my-2" />
        <languageBar />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import languageBar from "@/components/languageBar";
import { mapGetters } from "vuex";

export default {
  name: "menuMatrix",
  components: {
    languageBar,
  },
  data() {
    return {
      // isPaymentPopupVisible: false,
      menu: {
        height: null,
        width: null,
        col: null,
        imageWidth: null,
      },
      noInternet: ["Maps"],
    };
  },
  computed: {
    ...mapGetters([
      "getCMSlink",
      "getTouchCount",
      "isUserLooking",
      "getAvatarLangCodes",
      "getSessionId",
      "getKioskProfile",
      "getPaymentPopUp",
      "getNetworkConnection",
      "getGreetingStatus",
      "getenableADA",
    ]),

    filteredPages() {
      return this.$t("homepages")
        .filter(
          (page) =>
            page.alias !== "payment" ||
            (page.alias === "payment" &&
              ["payments", "pagos"].includes(page.pageName.toLowerCase()))
        )
        .sort((a, b) => a.displayPosition - b.displayPosition); // Sort by displayPosition
    },
    paymentPages() {
      return this.$t("homepages").filter(
        (page) =>
          page.alias === "payment" &&
          page.pageName.toLowerCase() !== "payments" &&
          page.alias === "payment" &&
          page.pageName.toLowerCase() !== "pagos"
      );
    },
    showWelcomeDialog: {
      get() {
        return this.getShowWelcomeDialog;
      },
      set(val) {
        this.$store.commit("setShowWelcomeDialog", val);
      },
    },
  },
  methods: {
    goto(page) {
      console.log(page, "This is page");
      var date = new Date();
      // To start session using touch - when no face detected
      if (!this.isUserLooking) {
        this.$store.commit("setTouchCount", this.getTouchCount + 1);
        console.log(this.getTouchCount, " this is the touchCount in MM");
        if (this.getTouchCount === 1) {
          this.$store.dispatch("addSessionDataToStrapi", {
            applicationId: this.getKioskProfile.data().applicationId,
            actionType: "Session Started",
            applicationSessionId: this.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "Default",
              action: "Touch Detected",
              response: "User Session Started",
              timeStamp: date.toISOString(),
            },
          });
        }
        this.$store.dispatch("addInteractionToPostgres", {
          actionType: "Session Started",
          actionPayload: { recognitionType: "Touch" },
        });
      }

      if (page.pageType.length !== 0) {
        switch (page.pageType[0].__typename) {
          case "ComponentHomepageNavigation":
            this.$store.commit("setRequestQna", false);
            this.$store.commit("setIsThinking", false);
            this.$store.commit("setSpeechRecognitionHandler", false);
            this.$router.push("/" + page.pageType[0].pathName.toLowerCase());
            this.$store.commit("setPageHeader", page.pageType[0].pageHeader);
            this.$store.commit("setQnaKeyword", "");

            // To start session using touch - when no face detected
            // if (!this.isUserLooking) {
            //   this.$store.commit("setTouchCount", this.getTouchCount + 1);
            //   console.log(this.getTouchCount, " this is the touchCount in MM");
            //   if (this.getTouchCount === 1) {
            //     this.$store.dispatch("addSessionDataToStrapi", {
            //       applicationId: this.getKioskProfile.data().applicationId,
            //       actionType: "Session Started",
            //       applicationSessionId: this.getSessionId,
            //       timeStamp: date.toISOString(),
            //       sessionPayload: {
            //         module: "Default",
            //         action: "Touch Detected",
            //         response: "User Session Started",
            //         timeStamp: date.toISOString(),
            //       },
            //     });
            //   }
            // }

            // Will be called irrespective of Touch Count
            this.$store.dispatch("addSessionDataToStrapi", {
              applicationId: this.getKioskProfile.data().applicationId,
              actionType: "Touch",
              applicationSessionId: this.getSessionId,
              timeStamp: date.toISOString(),
              sessionPayload: {
                module: "Home Page",
                action: "navigate",
                response: page.pageType[0].pathName,
                timeStamp: date.toISOString(),
              },
            });

            this.$store.dispatch("addInteractionToPostgres", {
              actionType: "Interaction",
              actionPayload: {
                module: "Home Page",
                navigateFrom: "Home Page",
                navigateTo: page.pageType[0].pathName,
                interactionType: "Touch",
                elementContent: page.pageType[0].pathName,
              },
            });

            // this.$store.commit("setDefaultBubbleText", true);
            //this.$store.dispatch('avatarSpeak', page.speech)
            this.$store.commit("setTextBubbleText", page.speech);
            window.sayText(
              page.speech,
              this.getAvatarLangCodes.voiceId,
              this.getAvatarLangCodes.langId,
              this.getAvatarLangCodes.engineId
            );

            break;
          case "ComponentHomepageDialogBox":
            console.log("Opening Component Dialog Box : ");

            // To start session using touch - when no face detected

            if (page.pageType[0].type === "url") {
              this.$store.dispatch("addSessionDataToStrapi", {
                applicationId: this.getKioskProfile.data().applicationId,
                actionType: "Touch",
                applicationSessionId: this.getSessionId,
                timeStamp: date.toISOString(),
                sessionPayload: {
                  module: `Home Page`,
                  action: "Open URL",
                  response: `${page.pageName}`,
                  timeStamp: date.toISOString(),
                },
              });

              this.$store.dispatch("addInteractionToPostgres", {
                actionType: "Interaction",
                actionPayload: {
                  module: "Payments",
                  navigateFrom: "Home Page",
                  navigateTo: "Home Page",
                  interactionType: "Touch",
                  elementContent: page.alias,
                },
              });

              if (this.getPaymentPopUp) {
                this.showPaymentPopup();
              }
              // window.location.href = page.pageType[0].textList;

              if (this.getNetworkConnection) {
                // window.open(page.pageType[0].textList, "_blank");

                // open dialogBox Here.
                console.log("If dialog to open",page.speech);
                this.$store.commit("setTextBubbleText", page.speech);
                window.sayText(
                page.speech,
                this.getAvatarLangCodes.voiceId,
                this.getAvatarLangCodes.langId,
                this.getAvatarLangCodes.engineId
              );
                this.showWelcomeDialog = true;
              } else {
                const featureDisabledMsg =
                  "This feature is currently unavailable due to an internet connectivity issue.";
                // this.$store.dispatch('avatarSpeak', featureDisabledMsg)
                this.$store.commit("setTextBubbleText", featureDisabledMsg);
              }
            } else if (page.pageType[0].type === "textList") {
              this.$store.dispatch("avatarSpeak", page.speech);
              this.$store.commit("setTextBubbleText", page.speech);
              this.showPaymentPopup();
              window.sayText(
                page.speech,
                this.getAvatarLangCodes.voiceId,
                this.getAvatarLangCodes.langId,
                this.getAvatarLangCodes.engineId
              );
            }

            break;
          default:
            break;
        }
      }
    },

    showPaymentPopup() {
      // this.isPaymentPopupVisible = !this.isPaymentPopupVisible;

      //true ka false false ka true
      if (this.getPaymentPopUp) {
        this.$store.commit("setPaymentPopUp", false);
      } else {
        this.$store.commit("setPaymentPopUp", true);
      }

      if (!this.getPaymentPopUp) {
        console.log("popup is visible");
        this.$store.commit("setDefaultBubbleText", true);
        this.$store.commit(
          "setTextBubbleText",
          this.$i18n.t("bubbletextafteraction")
        );
      }
    },
  },
  mounted() {
    // if (this.$i18n.t('homepages').length <= 4) {
    //   this.menu = {
    //     height: 270,
    //     width: 280,
    //     col: 5,
    //     imageWidth: "60%"
    //   }
    // } else if (this.$i18n.t('homepages').length <= 6) {
    //   this.menu = {
    //     height: 260,
    //     width: 275,
    //     col: 4,
    //     imageWidth: "55%"
    //   }
    // }
    if (this.filteredPages.length <= 2) {
      this.menu = {
        height: 270,
        // width: 280,
        col: 6,
        imageWidth: "60%",
      };
    } else if (this.filteredPages.length <= 4) {
      this.menu = {
        height: 270,
        width: 280,
        col: 6,
        imageWidth: "60%",
      };
    } else if (this.filteredPages.length <= 6) {
      this.menu = {
        height: 260,
        width: 275,
        col: 4,
        imageWidth: "55%",
      };
    } else if (this.filteredPages.length <= 9) {
      this.menu = {
        height: 250,
        width: 300,
        col: 3,
        imageWidth: "60%",
      };
    }
  },
};
</script>

<style>
.menuItem {
  border: solid #2c6b87 !important;
}

.footer {
  bottom: 0 !important;
}
</style>
<i18n>
    {
      "en": {
          "default": "How Can I Help You?",
          "paymentDialogHeader": "Payments"
        },
      "es":{
          "default": "¿Le puedo ayudar en algo?",
          "paymentDialogHeader": "Pagos"
        }
    }
  </i18n>
